/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSwatchSelector_user = {
    readonly " $fragmentRefs": FragmentRefs<"SwatchSelector_user">;
    readonly " $refType": "PdpRespSwatchSelector_user";
};
export type PdpRespSwatchSelector_user$data = PdpRespSwatchSelector_user;
export type PdpRespSwatchSelector_user$key = {
    readonly " $data"?: PdpRespSwatchSelector_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSwatchSelector_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSwatchSelector_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_user",
      "args": null
    }
  ]
};
(node as any).hash = '7595c5be6c23d1e3712d8d28ffd08cef';
export default node;
